import useSessionStore from "../stores/sessionStore.js";

/**
 * usePlan — returns the current team's plan tier and helper booleans.
 *
 * Returns planLoading: true while Zustand hasn't hydrated the user yet,
 * so components can render a neutral state instead of briefly flashing
 * the locked/unlocked UI (H8 fix).
 *
 * Read from user.profile.* because authProvider stores the LoginResponse
 * as the profile object in localStorage and sessionStore.
 */
export default function usePlan() {
  const user = useSessionStore((s) => s.user);

  if (!user) {
    return {
      planLoading: true,
      plan: null,
      teamRole: null,
      teams: [],
      isPro: false,
      isEnterprise: false,
    };
  }

  const plan = user.profile?.team_plan ?? "hobby";

  return {
    planLoading: false,
    plan,
    teamRole: user.profile?.team_role ?? "member",
    teams: user.profile?.teams ?? [],
    isPro: plan !== "hobby",
    isEnterprise: plan === "enterprise",
  };
}
